import { useFormikContext } from "formik"
import { useDEFormContext } from "../context/DEFormContext"


const BasicDetails = () => {
    const formik = useFormikContext()
    const { unitOptions, subUnitOptions } = useDEFormContext()

    return (
        <>
            <div className="form-group row mb-3">
                <label className="col-sm-4 col-form-label">
                    Initiation Date <span style={{ color: 'red' }}>*</span>
                </label>
                <div className="col-sm-8">
                    <input
                        type="date"
                        className="form-control"
                        name="deInitiationDate"
                        value={formik.values.deInitiationDate}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        onClick={(e) => e.target.showPicker && e.target.showPicker()}
                    />
                    {formik.touched.deInitiationDate &&
                        formik.errors.deInitiationDate && (
                            <div className="invalid-feedback d-block">
                                {formik.errors.deInitiationDate}
                            </div>
                        )}
                </div>
            </div>
            <div className="form-group row mb-3">
                <label className="col-sm-4 col-form-label">
                    Unit of Initiation <span style={{ color: 'red' }}>*</span>
                </label>
                <div className="col-sm-8">
                    <select
                        className="form-control"
                        name="deUnit"
                        value={formik.values.deUnit}
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                    >
                        <option value="">Select Unit</option>
                        {unitOptions.map((opt) => (
                            <option key={opt.id} value={opt.id}>
                                {opt.name}
                            </option>
                        ))}
                    </select>
                    {formik.touched.deUnit && formik.errors.deUnit && (
                        <div className="invalid-feedback d-block">
                            {formik.errors.deUnit}
                        </div>
                    )}
                </div>
            </div>
            {subUnitOptions.length > 0 && (
                <div className="form-group row mb-3">
                    <label className="col-sm-4 col-form-label">
                        Sub Unit of Initiation <span style={{ color: 'red' }}>*</span>
                    </label>
                    <div className="col-sm-8">
                        <select
                            className="form-control"
                            name="deSubUnit"
                            value={formik.values.deSubUnit}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        >
                            <option value="">Select Sub Unit</option>
                            {subUnitOptions.map((opt) => (
                                <option key={opt.id} value={opt.id}>
                                    {opt.name}
                                </option>
                            ))}
                        </select>
                        {formik.touched.deSubUnit && formik.errors.deSubUnit && (
                            <div className="invalid-feedback d-block">
                                {formik.errors.deSubUnit}
                            </div>
                        )}
                    </div>
                </div>
            )}
            <div className="form-group row mb-3">
                <label className="col-sm-4 col-form-label">
                    Allegations <span style={{ color: 'red' }}>*</span>
                </label>
                <div className="col-sm-8">
                    <textarea
                        className="form-control"
                        name="deAllegations"
                        value={formik.values.deAllegations}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                    {formik.touched.deAllegations && formik.errors.deAllegations && (
                        <div className="invalid-feedback d-block">
                            {formik.errors.deAllegations}
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default BasicDetails